import React, { useEffect, useState } from "react";
import Popup from "../Popup/BasePopup";
import { getLevel } from "../../api/profile.api";
import { url } from "../../config/url";

const LevelsPopup = ({ isOpen, title, onClose }) => {
  const [levels, setLevels] = useState([]);

  useEffect(() => {
    const fetchLevels = async () => {
      try {
        const res = await getLevel();
        if (res?.success && res?.list) {
          setLevels(res.list);
        }
      } catch (error) {
        console.error("Error fetching levels:", error);
      }
    };

    fetchLevels();
  }, []);

  return (
    <Popup isOpen={isOpen} title={title} onClose={onClose}>
      <div className="user-levels-gj-container">
        <div className="user-levels-gj-scrollable" style={{flexDirection:"row"}}>
         
          {levels.map((item, index) => (
            <div key={index} className="user-levels-gj-card  ">
              <div className="user-levels-gj-level">Level {item.num}</div>
              <div className="user-levels-gj-body p-2">
                <div className="user-levels-gj-info">
                  <h3 className="user-levels-gj-name">
                  {item.name?.length > 10 ? (
                          <marquee>{item?.name}</marquee>
                        ) : (
                          item?.name
                        )}
                    {/* {item.name} */}
                    </h3>
                  {/* <p className="user-levels-gj-points">
                    <span>
                      {item.startPoint}
                      </span>-<span>
                        {item.endPoint}
                        </span> Points
                  </p> */}
                  <p className="user-levels-gj-points">
                    {`${item.startPoint}-${item.endPoint} Points`.length > 13 ? (
                      <marquee>
                        {`${item.startPoint}-${item.endPoint} Points`}
                      </marquee>
                    ) : (
                      `${item.startPoint}-${item.endPoint} Points`
                    )}
                  </p>
                </div>
                <div className="user-levels-gj-avatar">
                  <img
                    src={url?.IMAGE_URL + item.featuredImage?.default}
                    alt="avatar"
                  />
                </div>
              </div>
            </div>
          ))}
       
        </div>
      </div>
    </Popup>
  );
};

export default LevelsPopup;
